
import { RichMediaValue } from '@/interface/media';
import { NumericalSystemType } from '@/interface/numberSysytem';
import { StoryNumberListData } from '@/pages/numberSystem/setNumberTable/table';
import { transformObjectDeep } from '@/utils/tans/object';

import { apiPathServer } from './api-config';
import { CgiResp } from './cgi';
import { API_PREFIX, request } from './request';

export const defaultPageInfo = {
  total: 0,
  page: 1,
  size: 10,
};

export const getStoryNumberList = async (params: {
  storyId: string,
  botId?: string;
  name?: string;
  page?: number;
  size?: number;
  release?: boolean
}) => {
  const postData = transformObjectDeep({
    ...params,
    roleId: params?.botId,
    size: params?.size || 10,
  }, 'snake') || {};

  const res = await request(`${API_PREFIX}${apiPathServer.GetNumSysList}${params?.release ? '/release' : ''}`, {
    method: 'GET',
    query: { ...postData },
  });
  const postRes = transformObjectDeep({
    ...res,
  }, 'camel', true) as CgiResp<{
    list: StoryNumberListData[],
    pageinfo: {
      total: number;
      page: number
    }
  }>;
  return postRes;
};

export const setStoryNumber = async (params: {
  storyId: string;
  roleId: string;
  name: string; // 变量名
  type: NumericalSystemType, // 变量类型
  initScore: number;// 初始值
  minScore: number; // 最小值
  maxScore: number; // 最大值
  isVisible: boolean;// 是否用户可见
  iconUrl: string; // 图标
  id: string,
}) => {
  const postData = transformObjectDeep({
    ...params,
  }, 'snake') || {};
  const res = await request(`${API_PREFIX}${apiPathServer.PostNumSys}`, {
    method: 'POST',
    body: {
      ...postData,
      init_score: Number(params?.initScore || 0),
      max_score: Number(params?.maxScore || 0),
      min_score: Number(params?.minScore || 0),
    },
  });

  return transformObjectDeep({
    ...res,
  }, 'camel') as CgiResp<{

  }>;
};

export const changeRoleBgImage = async (params: {
  storyId: string;
  roleId: string;
  previewBgImage?: RichMediaValue
}) => {
  const postData = transformObjectDeep({
    ...params,
  }, 'snake') || {};
  const res = await request(`${API_PREFIX}${apiPathServer.ChangeRoleBgImage}`, {
    method: 'POST',
    body: {
      ...postData,
    },
  });

  return transformObjectDeep({
    ...res,
  }, 'camel') as CgiResp<{

  }>;
};


export const deleteStoryNumber = async (params: {
  ids: string[],
  storyId: string
}) => {
  const postData = transformObjectDeep({
    ...params,
  }, 'snake') || {};
  const res = await request(`${API_PREFIX}${apiPathServer.numSysDelete}`, {
    method: 'POST',
    body: { ...postData },
  });

  return transformObjectDeep({
    ...res,
  }, 'camel') as CgiResp<{}>;
};


export const getStoryNumberBotList = async (params: {
  storyId: string,
  id?: string;
  release?: boolean
}) => {
  const postData = transformObjectDeep({
    ...params,
  }, 'snake') || {};
  const res = await request(`${API_PREFIX}${apiPathServer.GetNumberSystemList}${params?.release ? '/release' : ''}`, {
    method: 'GET',
    query: { ...postData },
  });
  const postRes = transformObjectDeep({
    ...res,
  }, 'camel', true) as CgiResp<{
    roles: any[]
  }>;
  return postRes;
};


export const getStoryChooseNumberBotList = async (params: {
  storyId: string,
  id?: string
}) => {
  const postData = transformObjectDeep({
    ...params,
  }, 'snake') || {};
  const res = await request(`${API_PREFIX}${apiPathServer.GetNumChoiceSysList}`, {
    method: 'GET',
    query: { ...postData },
  });
  const postRes = transformObjectDeep({
    ...res,
  }, 'camel', true) as CgiResp<{
    roles: any[]
  }>;
  return postRes;
};

export const numSysRoleDel = async (params: {
  storyId: string;
  roleId: string;
}) => {
  const postData = transformObjectDeep({
    ...params,
  }, 'snake') || {};
  const res = await request(`${API_PREFIX}${apiPathServer.NumSysRoleDel}`, {
    method: 'POST',
    body: { ...postData },
  });

  return transformObjectDeep({
    ...res,
  }, 'camel') as CgiResp<{}>;
};


